export const selectASizeMessage =
  "Please select a size to see product availability at a store near you.";
export const cantFindItemInNearbyStoresMessage =
  "This size/colour combination is not available for Buy & Pick-up at any stores near you. Try selecting another size, colour or check all store inventory.";
